<script>
import TwButton from '@/components/generic/tw-button.vue'
import { UserPlusIcon } from '@heroicons/vue/24/outline'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserTeamSocialsShare from '@/components/fundraisers/fundraiser-team-socials-share.vue'
import FundraiserSubscribeToUpdatesModal from '@/components/fundraiser-updates/fundraiser-subscribe-to-updates-modal.vue'

export default {
  name: 'TeamActions',
  components: { FundraiserSubscribeToUpdatesModal, FundraiserTeamSocialsShare, TwModal, TwButton, UserPlusIcon },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <div class="flex flex-col gap-3">
    <tw-button :to="{ name: 'TeamDonatePage', params: { teamId: team.id } }" block size="lg" class="w-full" variant="primary">
      Donate
    </tw-button>
    <div class="flex gap-3">
      <tw-button block variant="secondary" class="text-md" @click="$refs.shareModal.open()">
        Share
      </tw-button>
      <tw-button block variant="secondary" class="text-md" @click="$refs.subscribeToTeamFundraiserModal.open()">
        Subscribe
      </tw-button>
    </div>
    <tw-button v-if="fundraiser.settings && fundraiser.settings.enable_supporters" :to="{ name: 'FundraiserTeamPublicJoinPage', params: { fundraiserId: fundraiser.id, teamId: team.id } }" block variant="dark">
      Join this Team and Fundraiser
      <UserPlusIcon class="h-4 w-4" />
    </tw-button>
    <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this team fundraiser" @ok="$refs.shareModal.close()">
      <fundraiser-team-socials-share :fundraiser="fundraiser" :team="team" />
    </tw-modal>
    <fundraiser-subscribe-to-updates-modal ref="subscribeToTeamFundraiserModal" :subscribable="fundraiser" />
  </div>
</template>

<style scoped>

</style>
